module.exports = __webpack_public_path__ + "img/1571097360.d22cb435.jpg";